/**
 * 应用入口
 *
 * 启动顺序很关键：
 *  1. 先从 localStorage 恢复会话（同步，很快）
 *  2. 再挂载应用
 *  3. 挂载后再异步校验一次会话是否仍然有效
 *
 * 为什么不在挂载前 await 校验：那会让首屏一直空白（网络慢时很明显）。
 * 先渲染，再校验；校验失败时由 401 处理跳登录页 —— 用户看到的是
 * 「短暂显示后台 → 跳登录」，而不是白屏。
 */
import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { api, setUnauthorizedHandler } from './api/client'
import { clearSession, restoreSession, saveSession } from './stores/session'
import './styles.css'

restoreSession()

// 任何接口返回 401 → 清会话 + 跳登录页。
// 注册在这里而不是 api 层内部，是为了避免 api 直接依赖 router（循环依赖）
setUnauthorizedHandler(() => {
  if (router.currentRoute.value.name !== 'login') {
    void router.replace({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } })
  }
})

const app = createApp(App)
app.use(router)

/**
 * 全局错误兜底。
 * 没有它的话，组件渲染期间抛出的异常会让整个页面变成空白 ——
 * 这正是任务 7.9 要求避免的「白屏」。
 */
app.config.errorHandler = (err) => {
  console.error('[admin] 未捕获的前端异常：', err)
}

app.mount('#app')

// 挂载后校验会话。失败不额外处理：api 层已经会清会话并跳登录页
if (router.currentRoute.value.name !== 'login') {
  void api
    .me()
    .then((admin) => {
      // 顺手刷新本地缓存的管理员信息（角色可能被超管改过）
      const token = localStorage.getItem('beadyard_admin_token')
      if (token) {
        saveSession(token, {
          id: admin.id,
          email: admin.email,
          displayName: admin.displayName,
          role: admin.role
        })
      }
    })
    .catch(() => {
      clearSession()
    })
}
